
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./uneeq-react-core.cjs.production.min.js')
} else {
  module.exports = require('./uneeq-react-core.cjs.development.js')
}
